import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdkDragDrop, moveItemInArray, DragDropModule } from '@angular/cdk/drag-drop';
import { HttpService } from '../http.service';

@Component({
  selector: 'app-image-uploader',
  standalone: true,
  imports: [CommonModule, DragDropModule],
  templateUrl: './image-uploader.component.html',
  styleUrls: ['./image-uploader.component.scss']
})
export class ImageUploaderComponent {

  @Input() type = 'single'
  @Input() set loadImage(v: any) {

    if (!v || this.is_init) {
      return;
    }

    this.is_init = true;
    this.files = this.type == 'single' ? [v] : v;
  }
  @Input() favicon = false;
  @Output() uploadEvent = new EventEmitter();
  @Output() deleteEvent = new EventEmitter();

  constructor(private http: HttpService) { }

  public is_loading: boolean = false;
  public error: string = '';
  private is_init = false;
  public files = [];

  onUploadChange(evt: any) {
    const file = evt.target.files[0];

    if (file && !this.is_loading) {
      this.is_loading = true;
      this.error = '';
      const reader = new FileReader();

      reader.onload = this.handleReaderLoaded.bind(this);
      reader.onerror = () => {
        this.error = 'Image could not be read. Please choose the file again.';
        this.is_loading = false;
      };
      reader.readAsDataURL(file);
      evt.target.value = '';
    }
  }

  async handleReaderLoaded(e) {
    this.is_loading = true;
    this.error = '';
    try {
      const y: any = await this.http.post("/admin/file-upload", { file: e.target.result, favicon: this.favicon });
      if (!y?.status || !y?.path) {
        this.error = y?.message || 'Image upload failed. Please try again before saving.';
        return;
      }
      // Keep the previous image until its replacement has uploaded successfully.
      this.files = this.type === 'single' ? [y.path] : [...this.files, y.path];
      this.uploadEvent.emit(this.files);
    } catch (error) {
      this.error = 'Image upload failed. Please try again before saving.';
    } finally {
      this.is_loading = false;
    }
  }

  async delete(i) {
    this.is_loading = true;

    let y: any = await this.http.post("/admin/file-remove", { file: this.files[i] });

    this.files.splice(i, 1);
    this.deleteEvent.emit(this.files)

    this.is_loading = false;

  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.files, event.previousIndex, event.currentIndex);
  }
}
